// Read-only SVG preview of a schematic snapshot. Used in Studio Concept panel
// and Portal Concepts page.
export default function SchematicPreview({ schematic, height = 200 }) {
  const items = schematic?.items || [];
  const w = 3000, h = 2400; // default wall dims — most snapshots use these bounds
  if (items.length === 0) {
    return (
      <div className="w-full flex items-center justify-center bg-muted" style={{ height }}>
        <div className="text-xs text-muted-foreground">No elevation yet</div>
      </div>
    );
  }
  return (
    <div className="w-full" style={{ background: "#F4F2EC" }}>
      <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="xMidYMid meet" style={{ width: "100%", height, display: "block" }}>
        <rect x="0" y="0" width={w} height={h} fill="#F4F2EC"/>
        {items.map((it, idx) => {
          const color = it.color || COLOR_FALLBACK[it.type] || "#5C5C5C";
          return (
            <g key={it.id || idx}>
              <rect
                x={it.x || 0} y={it.y || 0}
                width={it.width || 100} height={it.height || 100}
                fill={color} fillOpacity="0.85" stroke="#1C1C1C" strokeWidth="4"
              />
              {(it.width || 0) > 250 && (it.height || 0) > 100 && (
                <text
                  x={(it.x || 0) + (it.width || 0) / 2}
                  y={(it.y || 0) + (it.height || 0) / 2 + 20}
                  textAnchor="middle" fill="#FFF"
                  fontSize="60" fontFamily="Cormorant Garamond, serif"
                >{it.label || it.type}</text>
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
}

const COLOR_FALLBACK = {
  tv: "#1C1C1C",
  fireplace: "#B85C38",
  storage: "#8A7355",
  panel: "#A68A64",
  shelf: "#6B6157",
  lighting: "#F4CE8B",
};
